import { Copy } from 'smg/clipboard';
import { TrimPrefix } from 'smg/strings';
import { Success } from 'smg/toast';

document.body.addEventListener('click', e => {
    if (e.target instanceof HTMLAnchorElement && e.target.matches('.copy-email')) {
        e.preventDefault();
        Copy(TrimPrefix(e.target.href, 'mailto:'));
        Success('Email copied to clipboard!');
    }
});
